import script from "./ToolbarMunicipal.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarMunicipal.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarMunicipal.vue?vue&type=style&index=0&id=f7a27844&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a27844"]])

export default __exports__